import React, { useState, useEffect, useRef } from "react";
import { API_URL, FOLDERPATH } from "../Constants/config";
import axios from "axios";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import CandidateTab from "./CandidateTab";
import NotificationPanels from "./NotificationPanels";
import PersonalDetailsIcon from "../assets/img/personal-details-icon.png";
import "../assets/css/candidate-tab-form.css";
import "../assets/css/inner-tabs.css";
import TickIconBlack from "../assets/img/tick-icon-black.png";
import CrossIcon from "../assets/img/cross-icon.png";
import UploadIcon from "../assets/img/upload-icon.svg";
import ArrowRightIcon from "../assets/img/arrow-right-icon.png";
import CalendarIcon from "../assets/img/calendar-icon.svg";
import BagIcon from "../assets/img/bag-icon.svg";
import CallIcon from "../assets/img/call-icon.png";
import EmailIcon from "../assets/img/email-icon.png";
import { useDispatch, useSelector } from "react-redux";
import { creditCibilHistory, sendOTPCibilHistory, validateCibilOtp, saveCibilHistory, deleteSaveCibilDetails, skipStep, saveAlternateMobile, verifyAnswers, deleteSendOtpDetails,
 deleteValidateOtpDetails, deleteAlternateMobileDetails, deleteSkipCibilDetails, deleteVerifyAnsDetails } from "../Actions/creditCibilHistoryAction";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import ABYear from './Common/ABYear';
import ABUpload from './Common/ABUpload';
import ABText1 from './Common/ABText1';
import ABCarousel from './ABCarousel';
import ABSelect from './Common/ABSelect';
import GetMasterData from "./../Helper/masterData";
import InputField from "./InputField";
import Footer from './Footer.js';
import StepCount from "./Common/StepCount";
import {
  validateEmail,
  validateMobileNumber,
  validateAlphabetsAndSpace,
  validatePincode,
  validateNumeric,
  validatePAN
} from "../Helper/common";
import { getPincode, deletePincodeDetails } from '../Actions/creditExperianHistoryAction';
import Loader from "./Common/loader";
import GreenTickBigIcon from "../assets/img/tick-green-big-icon.svg";
import MobileIcon from "../assets/img/mobile-icon.svg";
import "../assets/css/otp-box.css";
import $ from "jquery";
import ClientSideBar from "./Partials/ClientSideBar";
import ClientHeader from "./Partials/ClientHeader";
import ProgressHeading from "./Common/ProgressHeading.jsx";


const CandidateCreditCibilHistory = () => {
  const navigate = useNavigate();
  const form = useRef();
  const [timer, setTimer] = useState(40);
  const [toggle, setToggle] = useState(false);
  const [count,setCount]=useState(1);
  const [consentFlag, setConsentFlag]= useState(0);
  const [flag, setFlag]= useState(0);
  const [newRecord, setNewRecord] = useState({});
  const [questionnaire, setQuestionnaire] = useState({});
  const [newRecord1, setNewRecord1] = useState({});
  const [gender, setGender] = useState({});
  const [msgReqId, setMsgReqId] = useState('This field is required.');
  const [idType, setIdType] = useState({});
  const [url, setUrl] = useState({});
  const [companyName, setCompanyName] = useState('');
  const [stateType, setStateType] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [creditData, setCreditHistoryData] = useState({});
  const [consentUrl, setConsentUrl] = useState({});
  const [formError, setFormError] = useState({});
  const [reference,setReference]=useState();
  const [formVal, setFormVal] = useState({});
  const [showProfilePreview, setShowProfilePreview] = useState(0);
  const [referenceData1, setPersonalReferenceData1] = useState({});
  const [CreditHistoryCompleted, setCreditHistoryCompleted] = useState(false);
  const [errorData, setErrorData] = useState({});
  const storeData = useSelector((state) => state.creditCibil);
  const [newValidationRecord, setNewValidationRecord] = useState({});
  const storeData2 = useSelector((state) => state.sendOtpCreditCibil);
  const [otpMatch, setOtpMatch]= useState({});
  const storeOtpMatch = useSelector((state) => state.otpMatchCibil);
  const { otpMatchCibilData, loading: OtpLoading, error: OtpError} = storeOtpMatch;
  const [role,setRole]=useState();
  useEffect(() => {
    if (typeof OtpLoading !== "undefined" && OtpLoading !== null) {
      if (OtpLoading === true) {
        setIsLoading(true);
      } else { setIsLoading(false); }

    }
  }, [OtpLoading]);

  let user = JSON.parse(localStorage.getItem('userVerificationCandidate'));
  let clientId;

  if(user && (user?.client_id || user?.bridge_client_id)){
    clientId = user?.client_id || user?.bridge_client_id;  
  }

  const storeAlterMobile = useSelector((state) => state.saveAlternateMobile);
  const { saveAlternateMobileData, loading: AMLoading, error: AMError} = storeAlterMobile;
  useEffect(() => {
    if (typeof AMLoading !== "undefined" && AMLoading !== null) {
      if (AMLoading === true) {
        setIsLoading(true);
      } else { setIsLoading(false); }

    }
  }, [AMLoading]);
  const storeSkipStep = useSelector((state) => state.saveSkipStep);
  const { saveSkipStepData, loading: SkipLoading, error: SkipError} = storeSkipStep;
  useEffect(() => {
    if (typeof SkipLoading !== "undefined" && SkipLoading !== null) {
      if (SkipLoading === true) {
        setIsLoading(true);
      } else { setIsLoading(false); }

    }
  }, [SkipLoading]);
  const storeVerifyAns = useSelector((state) => state.verifyAnswers);
  const { verifyAnswersData, loading: VrLoading, error: VrError} = storeVerifyAns;
  useEffect(() => {
    if (typeof VrLoading !== "undefined" && VrLoading !== null) {
      if (VrLoading === true) {
        setIsLoading(true);
      } else { setIsLoading(false); }

    }
  }, [VrLoading]);
  const storeData3 = useSelector((state) => state.saveCibil);
  const dispatch = useDispatch();
  const { creditCibilData, loading: getLoading, error: getError} = storeData;
  useEffect(() => {
    if (typeof getLoading !== "undefined" && getLoading !== null) {
      if (getLoading === true) {
        setIsLoading(true);
      } else { setIsLoading(false); }

    }
  }, [getLoading]);

  const autoLoginStore = useSelector((state) => state.autoLogin);
  const { autoLoginData, loadingLogin } = autoLoginStore;

  useEffect(() => {
    if (
      typeof autoLoginData?.status !== "undefined" &&
      autoLoginData?.status !== null
    ) {
      
     setRole(autoLoginData.data.user_role);
    }
  }, [autoLoginData, autoLoginStore]);

  useEffect(()=>{
    let list = JSON.parse(localStorage.getItem('userVerificationCandidate'));
      setReference(list.reference_number);
      if (typeof list.consent_complete !== "undefined" && list.consent_complete !== null) {
        setConsentFlag(list.consent_complete);
      }
  },[]);


  const { sendOtpCreditCibilData, loading: saveLoading, error: saveError} = storeData2;
  useEffect(() => {
    if (typeof saveLoading !== "undefined" && saveLoading !== null) {
      if (saveLoading === true) {
        setIsLoading(true);
      } else { setIsLoading(false); }

    }
  }, [saveLoading]);
  const { saveCibilData, loading: saveLoading1, error: saveError1} = storeData3;
  useEffect(() => {
    if (typeof saveLoading1 !== "undefined" && saveLoading1 !== null) {
      if (saveLoading1 === true) {
        setIsLoading(true);
      } else { setIsLoading(false); }

    }
  }, [saveLoading1]);

  useEffect(() => {
    //debugger;
    if (typeof saveCibilData.data !== "undefined" && saveCibilData.data !== null) {
      const group = saveCibilData.data.group ? saveCibilData.data.group.group_id : '';
      if (group == 'profile_preview') {
      navigate(
        `/case-initiation/profile-preview/${reference}`
      );
      dispatch(deleteSaveCibilDetails());
      } else if (typeof group != "undefined" && group != '') {
      navigate(
        `/case-initiation/check-detail/${reference}/${group}`
      );  
      dispatch(deleteSaveCibilDetails());
      }
   }
  }, [saveCibilData, storeData3]);
  
  useEffect(() => {
    
    if (typeof creditCibilData.data !== "undefined" && creditCibilData.data !== null) {
      let list = JSON.parse(localStorage.getItem('userVerificationCandidate'));
      const group = creditCibilData.data.group ? creditCibilData.data.group.group_id : '';
      if (group == 'profile_preview') {
      navigate(
        `/case-initiation/profile-preview/${list.reference_number}`
      );
      } else if (typeof group != "undefined" && group != '') {
      navigate(
        `/case-initiation/check-detail/${list.reference_number}/${group}`
      );  
      } else {
          setCreditHistoryData(creditCibilData.data['fields']);
          setCreditHistoryCompleted(creditCibilData.data['candidates'].credit_history_check_completed);
          setGender({'Male': 'Male', 'Female' : 'Female', 'Other' : 'Transgender'});
          setConsentUrl(creditCibilData.data['consent_url_cibil']);
          setIdType(creditCibilData.data['CIBIL_ID_TYEPS']);
          setCompanyName(creditCibilData.data['company_name']);
          setStateType(creditCibilData.data['states']);
          setShowProfilePreview(creditCibilData.data['showProfilePreview']);
          if (creditCibilData.data['CREDIT_BUREAU'] == 'CIBIL') {
            setUrl(`/case-initiation/check-detail/${list.reference_number}/8/cibil`);
          } else {
            setUrl(`/case-initiation/check-detail/${list.reference_number}/8`);
            navigate(
            `/case-initiation/check-detail/${list.reference_number}/8`
            );
          }
      }
      
    }
  }, [creditCibilData, storeData]);

  ///console.log(questionnaire);
  
  

  useEffect(() => {
    const fetchData = async () => {
      dispatch(creditCibilHistory());
    };
    fetchData();
  }, []);
   

  useEffect(() => {
    //debugger;
    if (typeof saveAlternateMobileData !== "undefined" && saveAlternateMobileData !== null) {
      if (saveAlternateMobileData.code == 0) {
        setCreditHistoryCompleted(true);
        var eleman = document.getElementById('isContinue');
        eleman.removeAttribute("disabled");
        modalShowHide('alternateMobile', 'hide');
        modalShowHide('thankyou', 'show');
        $('.thankmsg').html(saveAlternateMobileData.msg);
        dispatch(deleteAlternateMobileDetails());
      } else if (saveAlternateMobileData.code == 1) {
        modalShowHide('alternateMobile', 'hide');
        modalShowHide('otpPopup', 'show');
        $('.otpMsg').html(saveAlternateMobileData.otpMsg);
        handleStart();
        dispatch(deleteAlternateMobileDetails());
      } else if (saveAlternateMobileData.code == 3) {
        modalShowHide('alternateMobile', 'hide');
        setQuestionnaire(saveAlternateMobileData.questions);
        $('.radio_btn').prop('checked', false);
        setNewRecord({});
        modalShowHide('questionnaire', 'show');
        dispatch(deleteAlternateMobileDetails());
      }
   }
  }, [saveAlternateMobileData, storeAlterMobile]);

    useEffect(() => {
    let counter;
    if (toggle) {
      counter = setInterval(() => {
        if (timer > 0) {
          setTimer(timer => timer - 1);
        } else {
          setTimer(0);
          clearInterval(counter);
          setToggle(false);
        }
      }, 1000);
    }
    return () => clearInterval(counter);
  }, [toggle]);

  const handleStart = () => {
    setTimer(40);
    setToggle(true);
    setErrorData((prevState) => ({
      ...prevState,
      ['otp']: false,
    }));
  };

  const [data,setData]=useState([]);
  const [cityName,setCityName]=useState();
  const [stateName,setStateName]=useState();

  const storePincodeData = useSelector((state) => state.getCityState);
  const { getCityStateData, loading, error } = storePincodeData;

  useEffect(() => {
    if (typeof getCityStateData.data !== "undefined" && getCityStateData.data !== null) {
      let updatedOtherDetails = _.cloneDeep(creditData);
      setErrorData((prevState) => ({
        ...prevState,
        ['city']: false,
      }));
      updatedOtherDetails['city'].field_value = getCityStateData.data.city_name;
      setCreditHistoryData(updatedOtherDetails);
      dispatch(deletePincodeDetails());
    }
  }, [getCityStateData, storePincodeData]);

  
  useEffect(() => {
    if (typeof sendOtpCreditCibilData !== "undefined" && sendOtpCreditCibilData !== null) {
      if (sendOtpCreditCibilData.code == 0) {
        $('#SendOTP').attr("disabled", "disabled");
        setCreditHistoryCompleted(true);
        modalShowHide('thankyou', 'show');
        $('.thankmsg').html(sendOtpCreditCibilData.msg);
        dispatch(deleteSendOtpDetails());
      } else if (sendOtpCreditCibilData.code == 1 ) {
        modalShowHide('otpPopup', 'show');
        handleStart();
        $('.otpMsg').html(sendOtpCreditCibilData.otpMsg);
        dispatch(deleteSendOtpDetails());
      } else if (sendOtpCreditCibilData.code == 2 ) {
        modalShowHide('otpPopup', 'hide');
        setaltMobileVal('');
        modalShowHide('alternateMobile', 'show');
        dispatch(deleteSendOtpDetails());
      }
    }
  }, [sendOtpCreditCibilData, storeData2]);

  useEffect(() => {
    if (typeof otpMatchCibilData !== "undefined" && otpMatchCibilData !== null) {
      if (otpMatchCibilData.code == 0 || otpMatchCibilData.code == 1) {
        setCreditHistoryCompleted(true);
        modalShowHide('otpPopup', 'hide');
        modalShowHide('thankyou', 'show');
        $('.thankmsg').html(otpMatchCibilData.msg);
        dispatch(deleteValidateOtpDetails());
      } else if (otpMatchCibilData.code == 2 ) {
        modalShowHide('otpPopup', 'hide');
        setaltMobileVal('');
        modalShowHide('alternateMobile', 'show');
        dispatch(deleteValidateOtpDetails());
      } else if (otpMatchCibilData.code == 3 ) {
        setQuestionnaire(otpMatchCibilData.questions);
        $('.radio_btn').prop('checked', false);
        setNewRecord({});
        modalShowHide('questionnaire', 'show');
        dispatch(deleteValidateOtpDetails());
      }
    }
  }, [otpMatchCibilData, storeOtpMatch]);

  useEffect(() => {
    if (typeof saveSkipStepData !== "undefined" && saveSkipStepData !== null) {
       if (saveSkipStepData.code == 3 ) {
        setQuestionnaire(saveSkipStepData.questions);
        $('.radio_btn').prop('checked', false);
        setNewRecord({});
        modalShowHide('questionnaire', 'show');
        dispatch(deleteSkipCibilDetails());
      }
    }
  }, [saveSkipStepData, storeSkipStep]);

  useEffect(() => {
    if (typeof verifyAnswersData !== "undefined" && verifyAnswersData !== null) {
      if (verifyAnswersData.code == 0 || verifyAnswersData.code == 1) {
        setCreditHistoryCompleted(true);
        modalShowHide('otpPopup', 'hide');
        modalShowHide('alternateMobile', 'hide');
        modalShowHide('questionnaire', 'hide');
        modalShowHide('thankyou', 'show');
        $('.thankmsg').html(verifyAnswersData.msg);
        $('#SendOTP').attr("disabled", "disabled");
        dispatch(deleteVerifyAnsDetails());
      }
    }
  }, [verifyAnswersData, storeVerifyAns]);


 const otp1 = useRef();
  const otp2 = useRef();
  const otp3 = useRef();
  const otp4 = useRef();
  const otp5 = useRef();
  const otp6 = useRef();
  
  const alt_mobile_number = useRef();
  const [otpVal1, setOtpVal1] = useState();
  const [otpVal2, setOtpVal2] = useState();
  const [otpVal3, setOtpVal3] = useState();
  const [otpVal4, setOtpVal4] = useState();
   const [otpVal5, setOtpVal5] = useState();
   const [otpVal6, setOtpVal6] = useState();
   const [altMobileVal, setaltMobileVal] = useState('');

  //Handling Initial States Floating Labels
  const [formData, setFormData] = useState({
    nameAsPerBank: null,
    dob: null,
    email: null,
    mobile: null,
    houseNumber: null,
    colony: null,
    pinCode: null,
    city: null,
    state: null,
    documentType: null,
  });

  const modalShowHide = (id, val) => {
    if (val == 'show') {
      $("#" + id).removeClass('hide');
      $("#" + id).addClass('show');
      setOtpVal1('');
      setOtpVal2('');
      setOtpVal3('');
      setOtpVal4('');
      setOtpVal5('');
      setOtpVal6('');
    } else {
      $("#" + id).removeClass('show');
      $("#" + id).addClass('hide');
      setOtpVal1('');
      setOtpVal2('');
      setOtpVal3('');
      setOtpVal4('');
      setOtpVal5('');
      setOtpVal6('');
    }
    };

  //Handling Floating Labels
  const handleFloatingLabels = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const saveDate = (id, val) => {
    console.log(id);
    let updatedOtherDetails = _.cloneDeep(creditData);
      updatedOtherDetails[id].field_value = val;
      setCreditHistoryData(updatedOtherDetails);
  };
  const handleInputChange = (e) => {
    let updatedOtherDetails = _.cloneDeep(creditData);
    if (e.target.name == 'pin_code') 
    {
      if (validatePincode(e.target.value)) {
         dispatch(getPincode(e.target.value));
         setErrorData((prevState) => ({
        ...prevState,
        ['pin_code']: false,
      }));
      } else {
        updatedOtherDetails['city'].field_value = '';
        updatedOtherDetails['state'].field_value = '';
           setErrorData((prevState) => ({
        ...prevState,
        ['pin_code']: true,
      }));
      }
    } else if (e.target.name == 'mobile_no') {
      if (validateMobileNumber(e.target.value)) {
         setErrorData((prevState) => ({
        ...prevState,
        ['mobile_no']: false,
      }));
      } else {
           setErrorData((prevState) => ({
        ...prevState,
        ['mobile_no']: true,
      }));
      }
    } else if (e.target.name == 'email_address') {
      if (validateEmail(e.target.value)) {
         setErrorData((prevState) => ({
        ...prevState,
        ['email_address']: false,
      }));
      } else {
           setErrorData((prevState) => ({
        ...prevState,
        ['email_address']: true,
      }));
      }
    } else if (e.target.name == 'id_number' && updatedOtherDetails['id_type'].field_value == 1 && !validatePAN(e.target.value)) {
        setErrorData((prevState) => ({
          ...prevState,
          ['id_number']: true,
        }));
        setMsgReqId('Please Enter a valid id Number.');
    } else if (e.target.name == 'state') {
      if (e.target.value != '') {
         setErrorData((prevState) => ({
        ...prevState,
        ['state']: false,
      }));
      } else {
           setErrorData((prevState) => ({
        ...prevState,
        ['state']: true,
      }));
      }
    } else if (e.target.name == 'address_line1') {
      if (e.target.value != '') {
         setErrorData((prevState) => ({
        ...prevState,
        ['address_line1']: false,
      }));
      } else {
           setErrorData((prevState) => ({
        ...prevState,
        ['address_line1']: true,
      }));
      }
    } else if (e.target.name == 'gender') {
      if (e.target.value != '') {
         setErrorData((prevState) => ({
        ...prevState,
        ['gender']: false,
      }));
      } else {
           setErrorData((prevState) => ({
        ...prevState,
        ['gender']: true,
      }));
      }
    } else if (e.target.name == 'id_type') { // IB-4870
      if (e.target.value != '') {
         setErrorData((prevState) => ({
        ...prevState,
        ['id_type']: false,
      }));
      } else {
           setErrorData((prevState) => ({
        ...prevState,
        ['id_type']: true,
      }));
      }
    } else {
        setErrorData((prevState) => ({
          ...prevState,
          ['id_number']: false,
        }));
    }
    updatedOtherDetails[e.target.name].field_value = e.target.value;
    setCreditHistoryData(updatedOtherDetails);
    /*if (e.target.name == 'mobile_no' && !validateNumeric(e.target.value)) { // IB-4870
       updatedOtherDetails[e.target.name].field_value = '';
       setCreditHistoryData(updatedOtherDetails);
    }*/
  };

  const saveCreditExperianDetails = async (e, action) => {
    e.preventDefault();
    let hasError = false;
    // debugger;
    let idTypeVal = _.cloneDeep(creditData['id_type'].field_value);
    console.log(idTypeVal);
      Object.entries(
        creditData
      ).map(([key, val]) => {
      if (
        val.is_mandatory == 1 &&
        (val.field_value == "" ||
          val.field_value == null)
      ) {
        hasError = true;
        setErrorData((prevState) => ({
          ...prevState,
          [key]: true,
        }));
      } else {
        if (key == 'email_address' || key == 'mobile_no' || key == 'pin_code' || key == 'id_number') {
          if (key == 'email_address' && !validateEmail(val.field_value)) {
            hasError = true;
            setErrorData((prevState) => ({
              ...prevState,
              ['email_address']: true,
            }));
          } if (key == 'mobile_no' && !validateMobileNumber(val.field_value)) {
            hasError = true;
            setErrorData((prevState) => ({
              ...prevState,
              ['mobile_no']: true,
            }));
          } if (key == 'pin_code' && !validatePincode(val.field_value)) {
            hasError = true;
            setErrorData((prevState) => ({
              ...prevState,
              ['pin_code']: true,
            }));
          } if (key == 'id_number') {
              if (key == 'id_number' && idTypeVal == 1 && !validatePAN(val.field_value)) {
                  hasError = true;
                  setErrorData((prevState) => ({
                    ...prevState,
                    ['id_number']: true,
                  }));
                  setMsgReqId('Please Enter a valid id Number.');
              } else {
                  setErrorData((prevState) => ({
                    ...prevState,
                    ['id_number']: false,
                  }));
              }
            }
        } else {
          setErrorData((prevState) => ({
            ...prevState,
            [key]: false,
          }));
        }  
      }
    })
    if (!$('#checkbox1').is(":checked")) {
      hasError = true
      setErrorData((prevState) => ({
          ...prevState,
          ['consent1']: true,
        }));
    } if (!$('#checkbox2').is(":checked")) {
      hasError = true
      setErrorData((prevState) => ({
          ...prevState,
          ['consent2']: true,
        }));
    }
    console.log(errorData);
    if (hasError == true) {
      window.scroll({ top: 0, left: 0, behavior: "smooth" });
      return;
    } else {
      const formData = getFormData();
      formData['type'] = action;
      console.log(formData);
      dispatch(sendOTPCibilHistory(formData));
    }
  };   

  const getFormData = () => {
    const formData = {};
    Object.entries(
        creditData
      ).map(([key, val]) => {
          formData[key] = val.field_value;
      })
    return formData;
  };  
//console.log(formData);
const handleOtpInputs = (e) => {
    
    if(e.target.name=="otp1"){
      setOtpVal1((v) => (e.target.validity.valid ? e.target.value : ''))
      
      e.target.focus();
    }
    if(e.target.name=="otp2"){
      setOtpVal2((v) => (e.target.validity.valid ? e.target.value : ''))
      
    }
    if(e.target.name=="otp3"){
      setOtpVal3((v) => (e.target.validity.valid ? e.target.value : ''))
      
    }
    if(e.target.name=="otp4"){
      setOtpVal4((v) => (e.target.validity.valid ? e.target.value : ''))
      
    }
    if(e.target.name=="otp5"){
      setOtpVal5((v) => (e.target.validity.valid ? e.target.value : ''))
      
    }
    if(e.target.name=="otp6"){
      setOtpVal6((v) => (e.target.validity.valid ? e.target.value : ''))
      
    }
    const finalOtp1 =
      otp1.current.value +
      otp2.current.value +
      otp3.current.value +
      otp4.current.value +
      otp5.current.value +
      otp6.current.value;
    if (finalOtp1.length == 6) {
        setErrorData((prevState) => ({
          ...prevState,
          ['otp']: false,
        }));
    } else {
      setErrorData((prevState) => ({
          ...prevState,
          ['otp']: true,
        }));
    }
    let currentInput = e.target;
    if(e.target.validity.valid==false){
      e.target.focus();
    }
else{
    if(currentInput.value){
    if (currentInput.nextElementSibling !== null) {
      currentInput.nextElementSibling.focus();
    } 
  }
  if(!currentInput.value){
    currentInput.previousElementSibling.focus();
  }
}
  };
  const handleCheckbox = (e) => {
    let checkid = e.target.id;
    let checked = e.target.checked;
    if (checkid == 'credit_instruction_consent' && checked == true) {
      setFlag(1);
    } else {
      setFlag(0);
    }
    };

    const handleCheckboxConsent = (e) => {
    if ($('#checkbox1').is(":checked")) {
       setErrorData((prevState) => ({
            ...prevState,
            ['consent1']: false,
          }));
    }
    if ($('#checkbox2').is(":checked")) {
       setErrorData((prevState) => ({
            ...prevState,
            ['consent2']: false,
          }));
    }
    };

    const handleCheckboxOtp = (e) => {
    let checkid = e.target.id;
    let checked = e.target.checked;
    if (checkid == 'checkboxOtp' && checked == true) {
      var eleman = document.getElementById('verifyOtp');
      eleman.removeAttribute("disabled");
    } else {
      var eleman = document.getElementById('verifyOtp');
      eleman.setAttribute("disabled", "disabled");
    }
    };

    const handleCheckboxSkip = (e) => {
    let checkid = e.target.id;
    let checked = e.target.checked;
    if (checkid == 'checkboxSkip' && checked == true) {
      var eleman = document.getElementById('verifySkip');
      eleman.removeAttribute("disabled");
    } else {
      var eleman = document.getElementById('verifySkip');
      eleman.setAttribute("disabled", "disabled");
    }
    };
   
   const handleConsent = (e, url) => {
      setConsentFlag(1);
      let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate'));
      userLocalData.consent_complete = 1;
      console.log(userLocalData);
      localStorage.setItem('userVerificationCandidate', JSON.stringify(userLocalData));
      navigate(url);
    }; 
    

    const handleAlterInputs = (e) => {
    //e.preventDefault();
    if(e.target.name == "alt_mobile_number") {
      setaltMobileVal((v) => (e.target.validity.valid ? e.target.value : ''))
      e.target.focus();
    }
     //console.log(altMobileVal);
    }

    const handleAnsInputs = (e) => {
    setNewRecord((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
     //console.log(newRecord);
    }
    

  const verifyOtpHandler = async (e) => {
    e.preventDefault();
    const finalOtp =
      otp1.current.value +
      otp2.current.value +
      otp3.current.value +
      otp4.current.value +
      otp5.current.value +
      otp6.current.value;
      if (finalOtp == '') {
        setErrorData((prevState) => ({
              ...prevState,
              ['otp']: true,
            }));
      } else {
        if (finalOtp.length != 6) {
            setErrorData((prevState) => ({
              ...prevState,
              ['otp']: true,
            }));
        } else {
         dispatch(validateCibilOtp(finalOtp));
        }
      }
      
  };

  const saveCreditExperianUserDetails = async (e) => {
    e.preventDefault();
      dispatch(saveCibilHistory());
  };

  const saveVerifyAnswers = async (e) => {
    e.preventDefault();
    console.log(Object.keys(newRecord).length);
    if (newRecord == null && newRecord == '') {
       setErrorData((prevState) => ({
              ...prevState,
              ['question']: true,
            }));
    } else {
       if (Object.keys(newRecord).length !== 5) {
          setErrorData((prevState) => ({
              ...prevState,
              ['question']: true,
            }));
       } else {
         setErrorData((prevState) => ({
              ...prevState,
              ['question']: false,
            }));
         const recordData = {
            "answer" : {...newRecord},
         }
         console.log(recordData);
         dispatch(verifyAnswers(recordData));
       }
    }
  };
   
  const [runRequest, setRunRequest] = useState(0);

  const resetOtpHandler = () => {
    
    let apiCompanyData;

    const runAPi = async () => {

      let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate')); 

      const requestData = {
        token: userLocalData.id,
        type : "RESEND_CREDIT_OTP"
      };
      const headers = {
        "Content-Type": "application/json",
        Username: "ibridge",
        Password: "ibridge@2020",
      };

      const { data : result } = await axios.post(FOLDERPATH +
        "/CandidateApi/creditHistory",
        requestData,
        {
          headers,
        }
      );

      if (result.success == "1") {

      const { data } = result;

      const msg = result.msg;

      toast.success(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

    } else {

      const msg = result.msg;

      toast.error(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

    }
      // Reset the timer here
      handleStart();

      setCount(count+1);
    };

    runAPi();
  };


  const verifySkipHandler = async (e) => {
    e.preventDefault();
    dispatch(skipStep());
  };

  const verifyAltMobile = async (e) => {
    e.preventDefault();
    if (altMobileVal == '') {
        setErrorData((prevState) => ({
              ...prevState,
              ['alt_mobile_number']: true,
            }));
    } else {
      if (altMobileVal.length != 10) {
          setErrorData((prevState) => ({
            ...prevState,
            ['alt_mobile_number']: true,
          }));
      } else {
        setErrorData((prevState) => ({
            ...prevState,
            ['alt_mobile_number']: false,
          }));
       dispatch(saveAlternateMobile(altMobileVal));
      }
    }
  };

  const {
    countryCodeOptions,
  } = GetMasterData();
  const optionsKey = {
    country_codes: countryCodeOptions,
  };
  const optionsStatic = [{label: {text: "+91", value: 91, 
                        "data-subtext": "India"
                        },
                        value: "0"}];

  const handleCountryCode = (e) => {
    let updatedOtherDetails = _.cloneDeep(creditData);
    updatedOtherDetails['mobile_code'].field_value = e.target.value;
    setCreditHistoryData(updatedOtherDetails);
  };

  const handleSubmitForPreview = (e) => {
    e.preventDefault();
    navigate(`/case-initiation/profile-preview/${reference}`);
  };
    
  return (
    <>
    {isLoading && <Loader />} 
      <NotificationPanels />
      {role=="EP"? <ClientHeader />:<Header/>}
      {role=="EP"? <ClientSideBar /> :<Sidebar/>}
      {/* <Header />
      <Sidebar /> */}
      <section
        className="main-section candidate-tab-form"
        style={{ paddingTop: "60px" }}
      >
        <div className="container-fluid">
          <div className="row">
            <div className="col-auto bg-gray-mbl">
              <ProgressHeading/>
              <CandidateTab activeTab={"Credit History"} />
            </div>
            <div className="col bg-gray-mbl">
              {/*Form*/}

              <form
                ref={form}
                className="p-3 form2 form-section"
                style={{ minHeight: "700px" }}
              >
                <StepCount activeTab={"Credit History"}/>
                <h2 className="fnt-smi-bld">Credit History</h2>
                <p className="text-muted">
                  We will be obtaining your Credit Information Report from one of the credit bureau as part of the process. Please provide the following information for the same.
                  Kindly ensure that the mobile number and email address entered here must be associated with your bank and credit cards.
                </p>
                <hr />
                {consentFlag == 0 && consentFlag == '' &&
                <div className="d-block">
                <h6 className="fnt-smi-bld mt-3">Instructions</h6>
                <p className="text-muted">Kindly note that our Credit Bureau Partner (Experian/CIBIL) will release your Password Protected Credit Information Report (CIR) using the information provided by you. Step by step methodology of this process has been listed below for your reference.</p>

                <h6 className="fnt-smi-bld mt-3">How it works</h6>
                <p className="text-muted"><span className="fnt-smi-bld text-dark">Step 1 :</span> You will be required to enter the E-mail Address and Mobile Number associated with your bank on the next page (Credit History form). You will receive an OTP on the entered Mobile Number. This 6-digit OTP needs to be entered to proceed further.</p>

                <p className="text-muted"><span className="fnt-smi-bld text-dark">Step 2 :</span> As per RBI guideline, a copy of your credit report (password protected) will be sent to the E-mail ID provided by you on the credit history page. This report will have a detailed analysis of your credit history.</p>

                <p className="text-muted">Note – AuthBridge will Only consume the address history details from the credit bureau report for address verification purposes.</p>

                <p className="text-muted"><span className="fnt-smi-bld text-dark">Step 3 :</span> AuthBridge would extract the addresses history from the Credit Bureau Report only for the purpose of Address Verification. Post that, the Credit Report will be deleted from the system automatically and will no longer be available to any individual in AuthBridge or {companyName}.</p>

                <p className="text-muted">Note - Address history extraction process is automated and has no human intervention.</p>

                <div className="form-check mt-3">
                  <input type="checkbox" className="form-check-input" id="credit_instruction_consent" onChange={(e) => handleCheckbox(e)} />
                  <label htmlFor="credit_instruction_consent" className="form-check-label fnt-smi-bld">By clicking I read & accept, here by I: <sup className="text-danger">*</sup></label>
                </div>

                <p className="text-muted">Understand the above process and agree that the generated credit report will only be used to verify my Address History provided in this form. This is a required field.</p>

                <div className="row mt-3">
                  <div className="col-md-3">
                    {/*<button className="btn btn-outline-secondary btn-lg mt-3 mr-2">Back</button>*/}
                    {flag == 0 && flag == '' ? ( 
                        <Link to='#' className="text-primary no-effect-link">
                      <button type = 'button'className="btn btn-primary btn-md btn-block mt-3" disabled id="credit_instruction_consent_save" onClick={(e) => handleConsent(e, url)}>
                      Proceed
                      </button>
                     </Link>
                        ) : ( 
                       <Link to='#' className="text-primary no-effect-link">
                      <button type = 'button'className="btn btn-primary btn-md btn-block mt-3" id="credit_instruction_consent_save" onClick={(e) => handleConsent(e, url)}>
                      Proceed
                      </button>
                     </Link>
                        )} 
                  </div>
                </div>
                </div>    
                }
                { consentFlag === 1 &&
                 <> 
                <div className="row">
                  {creditData.first_name ? 
                    <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                    <InputField
                    inputType={
                      creditData.first_name.input_type
                    }
                    inputName={`first_name`}
                    inputValue={
                      creditData.first_name.field_value
                    }
                    isInputMandatory={
                      creditData.first_name.is_mandatory
                    }
                    inputLabel={
                      creditData.first_name.label
                    }
                    readOnly={true}
                    handleOnChange={handleInputChange}
                    />
                    {errorData[`first_name`
                      ] == true ? ( 
                        <p className="text-danger">
                        This field is required.
                        </p>
                        ) : ''}
                      </div>
                      </div>
                      : <></>
                    }
                  {creditData.middle_name ? 
                    <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                    <InputField
                    inputType={
                      creditData.middle_name.input_type
                    }
                    inputName={`middle_name`}
                    index={`email_id`}
                    readOnly={true}
                    inputValue={
                      creditData.middle_name.field_value
                    }
                    isInputMandatory={
                      creditData.middle_name.is_mandatory
                    }
                    inputLabel={
                      creditData.middle_name.label
                    }
                    handleOnChange={handleInputChange}
                    />
                    {errorData[`middle_name`
                      ] == true ? ( 
                        <p className="text-danger">
                        This field is required.
                        </p>
                        ) : ''}
                      </div>
                      </div>
                      : <></>
                    }
                </div>

                <div className="row">
                  {creditData.last_name ? 
                    <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                    <InputField
                    inputType={
                      creditData.last_name.input_type
                    }
                    inputName={`last_name`}
                    index={`email_id`}
                    inputValue={
                      creditData.last_name.field_value
                    }
                    isInputMandatory={
                      creditData.last_name.is_mandatory
                    }
                    readOnly={true}
                    inputLabel={
                      creditData.last_name.label
                    }
                    handleOnChange={handleInputChange}
                    />
                    {errorData[`last_name`
                      ] == true ? ( 
                        <p className="text-danger">
                        This field is required.
                        </p>
                        ) : ''}
                      </div>
                      </div>
                      : <></>
                    }
                  {creditData.email_address ? 
                    <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                    <InputField
                    inputType={
                      creditData.email_address.input_type
                    }
                    inputName={`email_address`}
                    index={`email_address`}
                    inputValue={
                      creditData.email_address.field_value
                    }
                    readOnly = {CreditHistoryCompleted ? true : false}
                    isInputMandatory={
                      creditData.email_address.is_mandatory
                    }
                    inputLabel={
                      creditData.email_address.label
                    }
                    handleOnChange={handleInputChange}
                    />
                    {errorData[`email_address`
                      ] == true ? ( 
                        <p className="text-danger">
                        {creditData.email_address.field_value != '' ? 'Please Enter a valid Email id.' : 'This field is required.'}
                        </p>
                        ) : ''}
                      </div>
                      </div>
                      : <></>
                    }
                </div>

                <div className="row">
                  {creditData.date_of_birth ? 
                    <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                    <InputField
                    inputType={
                      'date'
                    }
                    inputName={`date_of_birth1`}
                    index={`date_of_birth`}
                    inputValue={
                      creditData.date_of_birth.field_value
                    }
                    readOnly={true}
                    saveDate={saveDate}
                    showDate={creditData.date_of_birth.field_value}
                    isInputMandatory={
                      creditData.date_of_birth.is_mandatory
                    }
                    inputLabel={
                      creditData.date_of_birth.label
                    }
                    handleOnChange={handleInputChange}
                    />
                    {errorData[`date_of_birth`
                      ] == true ? ( 
                        <p className="text-danger">
                        This field is required.
                        </p>
                        ) : ''}
                      </div>
                      </div>
                      : <></>
                    }
                  {creditData.mobile_no ? 
                    <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                    <InputField
                    inputType={
                      creditData.mobile_no.input_type
                    }
                    inputName={`mobile_no`}
                    index={`mobile_no`}
                    inputValue={
                      creditData.mobile_no.field_value
                    }
                    isInputMandatory={
                      creditData.mobile_no.is_mandatory
                    }
                    countryCodeValue = {creditData.mobile_code.field_value}
                    handleCountryCode={(e) =>
                      handleCountryCode(e)
                    }
                    options={
                      optionsStatic
                        
                    }
                    readOnly = {CreditHistoryCompleted ? true : false}
                    inputLabel={
                      creditData.mobile_no.label
                    }
                    handleOnChange={handleInputChange}
                    />
                    {errorData[`mobile_no`
                      ] == true ? ( 
                        <p className="text-danger">
                        {creditData.mobile_no.field_value != '' ? 'Please Enter a valid mobile no.' : 'This field is required.'}
                        </p>
                        ) : ''}
                      </div>
                      </div>
                      : <></>
                    }
                </div>

                <div className="row">
                  {creditData.gender ? 
                    <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                    <InputField
                    inputType={
                      creditData.gender.input_type
                    }
                    inputName={`gender`}
                    index={`gender`}
                    inputValue={
                      creditData.gender.field_value
                    }
                    disabled = {CreditHistoryCompleted ? true : false}
                    options={
                      gender
                      ? gender
                      : []
                    }
                    isInputMandatory={
                      creditData.gender.is_mandatory
                    }
                    inputLabel={
                      creditData.gender.label
                    }
                    handleOnChange={handleInputChange}
                    />
                    {errorData[`gender`
                      ] == true ? ( 
                        <p className="text-danger">
                        This field is required.
                        </p>
                        ) : ''}
                      </div>
                      </div>
                      : <></>
                  }
                  {creditData.id_type ? 
                    <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                    <InputField
                    inputType={
                      creditData.id_type.input_type
                    }
                    inputName={`id_type`}
                    index={`id_type`}
                    inputValue={
                      creditData.id_type.field_value
                    }
                    disabled = {CreditHistoryCompleted ? true : false}
                    options={
                      idType
                      ? idType
                      : []
                    }
                    isInputMandatory={
                      creditData.id_type.is_mandatory
                    }
                    inputLabel={
                      creditData.id_type.label
                    }
                    handleOnChange={handleInputChange}
                    />
                    {errorData[`id_type`
                      ] == true ? ( 
                        <p className="text-danger">
                        This field is required.
                        </p>
                        ) : ''}
                      </div>
                      

                      </div>
                      : <></>
                    }
                </div>

                <div className="row">
                  {creditData.id_number ? 
                    <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                    <InputField
                    inputType={
                      creditData.id_number.input_type
                    }
                    inputName={`id_number`}
                    inputValue={
                      creditData.id_number.field_value
                    }
                    readOnly = {CreditHistoryCompleted ? true : false}
                    index={`id_number`}
                    isInputMandatory={
                      creditData.id_number.is_mandatory
                    }
                    inputLabel={
                      creditData.id_number.label
                    }
                    handleOnChange={handleInputChange}
                    />
                    {errorData[`id_number`
                      ] == true ? ( 
                        <p className="text-danger">
                        {creditData.id_number.field_value != '' ? 'Please Enter a valid Id Number.' : 'This field is required.'}
                        </p>
                        ) : ''}
                      </div>
                      </div>
                      : <></>
                    }
                  {creditData.address_line1 ? 
                    <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                    <InputField
                    inputType={
                      creditData.address_line1.input_type
                    }
                    inputName={`address_line1`}
                    inputValue={
                      creditData.address_line1.field_value
                    }
                    isInputMandatory={
                      creditData.address_line1.is_mandatory
                    }
                    readOnly = {CreditHistoryCompleted ? true : false}
                    index={`address_line1`}
                    inputLabel={
                      creditData.address_line1.label
                    }
                    handleOnChange={handleInputChange}
                    />
                    {errorData[`address_line1`
                      ] == true ? ( 
                        <p className="text-danger">
                        This field is required.
                        </p>
                        ) : ''}
                      </div>
                      </div>
                      : <></>
                    }
                </div>

                <div className="row">
                  {creditData.address_line2 ? 
                    <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                    <InputField
                    inputType={
                      creditData.address_line2.input_type
                    }
                    inputName={`address_line2`}
                    inputValue={
                      creditData.address_line2.field_value
                    }
                    isInputMandatory={
                      creditData.address_line2.is_mandatory
                    }
                    readOnly = {CreditHistoryCompleted ? true : false}
                    index={`address_line2`}
                    inputLabel={
                      creditData.address_line2.label
                    }
                    handleOnChange={handleInputChange}
                    />
                    {errorData[`address_line2`
                      ] == true ? ( 
                        <p className="text-danger">
                        This field is required.
                        </p>
                        ) : ''}
                      </div>
                      </div>
                      : <></>
                    }
                  {creditData.pin_code ? 
                    <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                    <InputField
                    inputType={
                      creditData.pin_code.input_type
                    }
                    inputName={`pin_code`}
                    inputValue={
                      creditData.pin_code.field_value
                    }
                    readOnly = {CreditHistoryCompleted ? true : false}
                    index={`pin_code`}
                    isInputMandatory={
                      creditData.pin_code.is_mandatory
                    }
                    inputLabel={
                      creditData.pin_code.label
                    }
                    handleOnChange={handleInputChange}
                    />
                    {errorData[`pin_code`
                      ] == true ? ( 
                        <p className="text-danger">
                        {creditData.pin_code.field_value != '' ? 'Please Enter a valid Pin Code.' : 'This field is required.'}
                        </p>
                        ) : ''}
                      </div>
                      </div>
                      : <></>
                    }
                </div>
                <div className="row">
                 {creditData.city ? 
                    <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                    <InputField
                    inputType={
                      1
                    }
                    inputName={`city`}
                    inputValue={
                      creditData.city.field_value
                    }
                    index={`city`}
                    isInputMandatory={
                      creditData.city.is_mandatory
                    }
                    readOnly = {CreditHistoryCompleted ? true : false}
                    inputLabel={
                      creditData.city.label
                    }
                    handleOnChange={handleInputChange}
                    />
                    {errorData[`city`
                      ] == true ? ( 
                        <p className="text-danger">
                        This field is required.
                        </p>
                        ) : ''}
                      </div>
                      </div>
                      : <></>
                    }
                 {creditData.state ? 
                    <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                    <InputField
                    inputType={
                      creditData.state.input_type
                    }
                    inputName={`state`}
                    index={`state`}
                    inputValue={
                      creditData.state.field_value
                    }
                    disabled = {CreditHistoryCompleted ? true : false}
                    options={
                      stateType
                      ? stateType
                      : []
                    }
                    isInputMandatory={
                      creditData.state.is_mandatory
                    }
                    inputLabel={
                      creditData.state.label
                    }
                    handleOnChange={handleInputChange}
                    />
                    {errorData[`state`
                      ] == true ? ( 
                        <p className="text-danger">
                        This field is required.
                        </p>
                        ) : ''}
                      </div>
                      

                      </div>
                      : <></>
                    }
                  </div>
                  </>
                 } 
                {/*<h6 className="fnt-smi-bld mb-0">Upload File</h6>

                <small className="text-muted">
                  upload one of following : Electricity Bill, Phone Bill, Voter
                  ID , Adhaar Card
                </small>
                <div className="row mt-3">
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                      <div className="floating-label">
                        <select
                          name="documentType"
                          id="documentType"
                          className="form-control"
                          onChange={handleFloatingLabels}
                        >
                          <option value=""></option>
                          <option value="d">d</option>
                        </select>
                        <label
                          htmlFor="batchEnd"
                          className={formData.documentType && "focused"}
                        >
                          Select Document Type
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="upload-box">
                      <div className="left d-flex align-items-center">
                        <img
                          src={TickIconBlack}
                          className="mr-2 pl-3 pr-3"
                          alt=""
                        />
                        <span>
                          <h6 className="m-0">Document uploaded</h6>
                          <small className="text-muted">6 Files uploaded</small>
                        </span>
                      </div>
                      <div className="right text-right">
                        <img src={CrossIcon} alt="" className="remove-btn" />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="upload-box">
                      <div className="left d-flex align-items-center">
                        <img src={UploadIcon} className="mr-2" alt="" />
                        <span>
                          <h6 className="m-0">Credit History</h6>
                          <small className="text-muted">
                            upload degree certificate
                          </small>
                        </span>
                      </div>
                      <div className="right text-right">
                        <img
                          src={ArrowRightIcon}
                          alt=""
                          className="remove-btn"
                        />
                      </div>
                    </div>
                  </div>
                </div>*/}
                { consentFlag == 1 && creditData.date_of_birth &&
                  <>
                <div className="form-check mt-3 mb-2">
                {CreditHistoryCompleted == true ? ( 
                  <input type="checkbox" checked className="form-check-input" id="checkbox1" onChange={(e) => handleCheckboxConsent(e)}  />

                  ) : ( 
                  <input type="checkbox" className="form-check-input" id="checkbox1" onChange={(e) => handleCheckboxConsent(e)}  />
                  )}
                  <label htmlFor="checkboxSkip" className="form-check-label fnt-smi-bld">I provide <a href={consentUrl} target = "_blank" download="Terms and Conditions">Consent</a> to TransUnion CIBIL for credit history.<sup className="text-danger">*</sup></label>
                  {errorData[`consent1`
                      ] == true ? (
                        <>
                        <br/>
                        <span className="ml-8 text-danger">
                        This field is required.
                        </span>
                        </>
                  ) : ''}
                  <br/>
                {CreditHistoryCompleted == true ? ( 
                  <input type="checkbox" checked className="form-check-input" id="checkbox2" onChange={(e) => handleCheckboxConsent(e)}  />

                  ) : ( 
                  <input type="checkbox" className="form-check-input" id="checkbox2" onChange={(e) => handleCheckboxConsent(e)}  />

                  )}                  <label htmlFor="checkboxOtp" className="form-check-label fnt-smi-bld">I consent and authorize AuthBridge to receive my credit Information from CIBIL and process it for my background verification request received by AuthBridge from its client/the company I am engaging with.<sup className="text-danger">*</sup></label>
                  {errorData[`consent2`
                      ] == true ? ( 
                        <p className="ml-8 text-danger">
                        This field is required.
                        </p>
                  ) : ''}
                </div>
                
              
                <div className="row mt-3">
                  <div className="col-auto d-flex justify-content-between">
                    {/*<button className="btn btn-outline-secondary btn-lg btn-block mt-3 mr-2">
                      Back
                    </button>*/}
                    {CreditHistoryCompleted == true ? ( 
                        <button type="button" className="btn btn-primary btn-lg btn-block mt-3 mr-2" disabled id = "SendOTP" onClick={(e) => saveCreditExperianDetails(e, 'SUBMIT_CREDIT_DATA')}>
                      Submit
                    </button>
                        ) : ( 
                        <button type="button" className="btn btn-primary btn-lg btn-block mt-3 mr-2" id = "SendOTP" onClick={(e) => saveCreditExperianDetails(e, 'SUBMIT_CREDIT_DATA')}>
                      Submit
                    </button>
                        )}
                    {CreditHistoryCompleted == true ? ( 
                        <button type="button" className="btn btn-primary btn-lg btn-block mt-3"  id = "isContinue" onClick={(e) => saveCreditExperianUserDetails(e)}>
                      Continue
                    </button>
                        ) : ( 
                        <button type="button" className="btn btn-primary btn-lg btn-block mt-3" disabled id = "isContinue" onClick={(e) => saveCreditExperianUserDetails(e)}>
                      Continue
                    </button>
                        )}
                    {/*<button type ="button" className="btn btn-primary btn-lg btn-block mt-3 mr-2" id = "SendOTP" onClick={(e) => saveCreditExperianDetails(e, 'SUBMIT_CREDIT_DATA')}>
                      Submit
                    </button>
                    <button type ="button" className="btn btn-primary btn-lg btn-block mt-3" id = "isContinue" onClick={(e) => saveCreditExperianUserDetails(e)}>
                      Continue
                    </button>*/}
                  </div>
                </div>
                </>
                }
                {showProfilePreview == 1 && (
                    <div className="row">
                      <div className="col-auto d-flex justify-content-between">
                        <button
                          className="btn btn-primary btn-lg btn-block mt-3"
                          onClick={(e) => handleSubmitForPreview(e)}
                        >
                          {clientId == 459831 ? "Preview" : "Submit for Preview"}
                        </button>
                      </div>
                      <div className="col-auto d-flex justify-content-between mt-4">
                        <small className="text-muted">
                          Please complete all the mandatory fields before final
                          submission
                        </small>
                      </div>
                    </div>
                  )}
              </form>

              {/*Form*/}
              {/*<div className="mt-4">
                <div className="row mb-3">
                  <div className="col-md-12 d-flex align-items-center btn-and-info-responsive">
                    <button className="btn btn-primary btn-lg mr-3">
                      Submit for Preview
                    </button>
                    <span className="text-muted">
                      Please complete the all mandatory fields before final
                      submission
                    </span>
                  </div>
                </div>
              </div>*/}
              <Footer />
            </div>
          </div>
        </div>
        <div className="dashboard custom-modal-dialog" id="alternateMobile">
        <div className="modal-wrapper">
          <div className="modal-content p-4 no-scroll">
            <span className="cstm-popup-close-btn" onClick={(e) => modalShowHide('alternateMobile', 'hide')}>
              &times;
            </span>
            <center>
              <img src={MobileIcon} width="50" alt=""/>
            </center>
            <form className="d-flex">
              <div className="m-4 justify-content-between w-100">
                <h4 className="fnt-bld text-center">Alternate Mobile no.</h4>
                <p
                  className="fnt-sml-md text-center text-danger"
                  style={{ color: "#667085" }}
                >
                  You’ve reached the maximum attempts kindly enter an alternative <br/>mobile number to receive the OTP
                </p>

                <div className="">
                  <div className="form-group d-flex justify-content-center">
                    <div class="floating-label has-right-icon">
                      <img src={CallIcon}/>
                      <input
                        type="text"
                        className="form-control"
                        maxLength="10" id="alternateMobileNo" autoComplete = "off" pattern="[0-9]*" name="alt_mobile_number" value={altMobileVal} onChange={handleAlterInputs}
                      />
                      <label htmlFor="alternateMobileNo" className={altMobileVal && "focused"}>Enter Mobile Number</label>
                      {errorData[`alt_mobile_number`
                        ] == true ? ( 
                          <p className="ml-8 text-danger fnt-sml-md">
                          Please enter a valid Mobile Number.
                          </p>
                          ) : ''}
                    </div>
                  </div>
                </div>
                <div className="text-center fnt-sml mt-3">
                    <span className="text-muted">Don't have any number? </span>
                      <Link
                        to="#"
                        onClick={(e) => verifySkipHandler(e)}
                        className="text-primary"
                      >
                        Skip this step
                      </Link>
                  </div>

                <div className="row mt-3">
                  <div className="col-md-12 d-flex justify-content-between">
                    <button type ="button" className="btn btn-outline-secondary btn-lg btn-block mt-3 mr-2" onClick={(e) => modalShowHide('alternateMobile', 'hide')}>Cancel</button>
                    <button type ="button" className="btn btn-primary btn-lg btn-block mt-3" onClick={(e) => verifyAltMobile(e)}>Submit</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      </section>
      <div className="dashboard custom-modal-dialog" id="otpPopup">
        <div className="modal-wrapper">
          <div className="modal-content p-4 no-scroll" >
          <span className="cstm-popup-close-btn" onClick={(e) => modalShowHide('otpPopup', 'hide')}>
              &times;
            </span>
            <center>
              <img src={MobileIcon} width="50" alt=""/>
            </center>
            <form ref={form} className="d-flex">
              <div className="m-4 form justify-content-between w-100">
                <h4 className="fnt-bld text-center">Please enter OTP</h4>
                <p
                  className="fnt-sml-md text-center otpMsg"
                  style={{ color: "#667085" }}
                >
                  The One Time Password is sent to Mobile Number 12345*****. <br/>Please enter the one time password.
                </p>
                <div className="">
                  <div className="form-group otp-inputs d-flex justify-content-center">
                    <input
                      type="text"
                      className="form-control fnt-bld"
                      maxLength="1"
                      ref={otp1}
                      autoComplete = "off"
                      name="otp1"
                      pattern="[0-9]*"
                      value={otpVal1}
                      onChange={handleOtpInputs}
                    />
                    <input
                      type="text"
                      className="form-control fnt-bld"
                      maxLength="1"
                      autoComplete = "off"
                      name="otp2"
                      ref={otp2}
                      pattern="[0-9]*"
                      value={otpVal2}
                      onChange={handleOtpInputs}
                    />
                    <input
                      type="text"
                      className="form-control fnt-bld"
                      maxLength="1"
                      autoComplete = "off"
                      name="otp3"
                      ref={otp3}
                      pattern="[0-9]*"
                      value={otpVal3}
                      onChange={handleOtpInputs}
                    />
                    <input
                      type="text"
                      className="form-control fnt-bld"
                      maxLength="1"
                      name="otp4"
                      autoComplete = "off"
                      ref={otp4}
                      pattern="[0-9]*"
                      value={otpVal4}
                      onChange={handleOtpInputs}
                    />
                    <input
                      type="text"
                      className="form-control fnt-bld"
                      maxLength="1"
                      name="otp5"
                      autoComplete = "off"
                      ref={otp5}
                      pattern="[0-9]*"
                      value={otpVal5}
                      onChange={handleOtpInputs}
                    />
                    <input
                      type="text"
                      className="form-control fnt-bld"
                      maxLength="1"
                      autoComplete = "off"
                      name="otp6"
                      ref={otp6}
                      pattern="[0-9]*"
                      value={otpVal6}
                      onChange={handleOtpInputs}
                    />
                  </div>
                  {errorData[`otp`
                      ] == true ? ( 
                        <center className="ml-8 text-danger fnt-sml-md">
                        Please enter a valid OTP.
                        </center>
                        ) : ''}
                </div>
                <div className="text-center fnt-sml mt-3">
                    <span className="text-muted">Didn’t get an otp? </span>
                      {timer > 0 ? ( 
                      <span className="text-muted">
                        
                        Resend OTP in {timer} Seconds{" "}
                      </span>):<>{ count==5 ? ( <span className="text-muted">
                        
                        No more attempts left{" "}
                        </span>):''}</>}
                      {timer < 0 && count<5 ? (
                        <Link
                          to="#"
                          className="text-primary"
                          onClick={resetOtpHandler}
                        >
                          Click to resend
                        </Link>
                      ) : (
                        ""
                      )}
                  </div>
                <div className="row mt-3">
                  <div className="col-md-12 d-flex justify-content-between">
                    {/*<button type="button"  className="btn btn-primary btn-lg btn-block mt-3 mr-2 " id="verifySkip"  onClick={(e) => verifySkipHandler(e)}>Skip</button>*/}
                    <button type="button" className="btn btn-primary btn-lg btn-block mt-3" id="verifyOtp"  onClick={(e) => verifyOtpHandler(e)}>Verify OTP</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="dashboard custom-modal-dialog" id="thankyou">
        <div className="modal-wrapper justify-content-center" style={{maxWidth:'300px'}}>
          <div className="modal-content p-4 no-scroll">
            <center>
              <img src={MobileIcon} width="50" alt=""/>
              <h6 className="fnt-smi-bld mt-3 mb-3">Thank You!</h6>
              <p className="text-muted thankmsg" >You will receive a copy of your credit information report directly also from the credit bureau on your registered email id for your records.</p>
            </center>
            <div className="row mt-3">
              <div className="col-md-12 d-flex justify-content-between">
                <button className="btn btn-primary btn-lg btn-block" onClick={(e) => modalShowHide('thankyou', 'hide')}>close</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="dashboard custom-modal-dialog" id="questionnaire">
        <div className="modal-wrapper justify-content-center">
          <div className="modal-content p-4 no-scroll">
            <h2 className="fnt-smi-bld">Complete the Questionaire</h2>
            <p className="text-muted mb-0">You will now be asked to complete a series of identify verification tasks based off your personal information. Please complete the task below and hit 'Submit' to proceed.</p>
            <div class="row">
              <div class="col-md-12">
              <hr/>
              </div>
            </div>
            <div style={{maxHeight: '600px', overflowY: 'auto', overflowX: 'hidden'}}>
            {questionnaire && Object.entries(questionnaire).map(([key, index]) => {
              key++;
              return (
                <>
                <h6 className="fnt-smi-bld mb-3">{key}. {index.text}</h6>
                {index.options && Object.entries(index.options).map(([i, val]) => {
                  return (
                    <div class="form-group">
                    <div class="form-check">
                    <input type="radio" name = {index.key} id={val.key} value ={val.key} className="form-check-input radio_btn" onChange={handleAnsInputs}/>
                    <label htmlFor={val.key} className="form-check-label">{val.value}</label>
                    </div>
                    </div>
                    )})}
                </>
                )
             })} 
            {errorData[`question`
              ] == true ? ( 
                <p className="ml-8 text-danger">
                Please answer all questions.
                </p>
                ) : ''}
              <div className="row mt-3">
                <div className="col-md-12 d-flex justify-content-center">
                  <button type ="button" className="btn btn-outline-secondary btn-lg  mr-2" onClick={(e) => modalShowHide('questionnaire', 'hide')}>Cancel</button>
                  <button  className="btn btn-primary btn-lg" onClick={(e) => saveVerifyAnswers(e)}>Submit</button>
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default CandidateCreditCibilHistory;
